(function (Lfl, $, undefined) {
    /*
     |==============================================================================================================
     | Documentation
     |==============================================================================================================
     */

    /**
     * Object that stores and provides language lines (translations).
     *
     * @memberOf Lfl
     */
    Lfl.Lang;

    (function (Lang, $, undefined) {
        /*
         |===========================================================================================================
         | Object definition
         |===========================================================================================================
         */

        // Note: At runtime this object is specifically set-up (via put()) for the current locale,
        //  so we store only lines for the current runtime locale here.

        var translations = {};
        var locale;

        /*
         |-----------------------------------------------------------------------------------------------------------
         | Public methods
         |-----------------------------------------------------------------------------------------------------------
         */

        /**
         *
         * @memberOf Lfl.Lang
         * @param {string} currentLocale
         */
        Lang.setLocale = function(currentLocale) {
            locale = currentLocale;
        };

        /**
         * @memberOf Lfl.Lang
         *
         * @return {string}
         */
        Lang.getLocale = function() {
            return locale;
        };

        /**
         * Adds all translations from map to known translations.
         *
         * Note: We could add 'key' parameter, to put the map at given key, but that can easily be done via JSON.
         *
         * @memberOf Lfl.Lang
         * @param map A map of lang keys to their translations.
         */
        Lang.put = function(map) {
            translations = addMapToTranslations(map, translations);
        };

        /**
         * @memberOf Lfl.Lang
         * @param {string} key The key to the lang line.
         */
        Lang.get = function(key) {
            var parts = key.split('.');
            var current = translations;

            for (var subkey in parts) {
                var value = current[parts[subkey]];
                // Return the key if translation not found.
                if (typeof value === "undefined") {
                   return key;
                }
                current = value;
            }

            return current;
        };

        /*
         |-----------------------------------------------------------------------------------------------------------
         | Private methods
         |-----------------------------------------------------------------------------------------------------------
         */
        function addMapToTranslations(map, translations) {
            // Foreach because Javascript is so advanced that it does not even have assoc. array merge. Call me salty.
            for (var key in map) {
                var value = map[key];

                if (typeof value === 'object') {
                    value = addMapToTranslations(value, {});
                }

                translations[key] = value;
            }

            return translations;
        }
    }(Lfl.Lang = Lfl.Lang || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
